export enum RecurringMode {
  END_AT = "endAt",
  MAX_OCCURRENCES = "maxOccurrences",
}
